import { createTheme } from '@mui/material/styles';
import { remCalc } from 'utils/remCalc';
import breakpoints from 'utils/breakpoints';
import mixins from 'utils/mixins';
import { getColor } from 'utils/colors';

const theme = createTheme({
	breakpoints: breakpoints,
	mixins: mixins,
});

const collapsePoint = 'sm';

export const overrides = {
	'footer': {
		'.footer__top': {
			padding: '40px 0',
			background: 'white',
			ul: {
				display: 'flex',
				listStyle: 'none',
				flexDirection: 'column',
				textAlign: 'center',
				margin: 0,
				padding: 0,
				justifyContent: 'space-between',
				gap: remCalc(24),
				flexWrap: 'wrap',
				li: {
					display: 'block',
					a: {
						display: 'block',
						color: getColor('ivory', 600),
						textDecoration: 'none',
						transition: 'all var(--transition-duration)',
						'&:hover': {
							color: getColor('ivory', 700),
						},
						'@media (prefers-contrast: more)': {
							color: getColor('ivory', 800),
							fontWeight: 500,
							'&:hover': {
								color: getColor('ivory', 900),
							},
						},
					}
				},
				[theme.breakpoints.up(collapsePoint)]: {
					flexDirection: 'row',
					textAlign: 'left',
					gap: remCalc(10),
				},
			}
		},
		'.footer__main': {
			padding: remCalc('64 30'),
			background: getColor('blue', 400),
			color: getColor('ivory', 400),
			textAlign: 'center',
			'a:link, a:visited': {
				color: 'white',
				fontWeight: 400,
			},
			'.footer__main__header': {
				fontWeight: 400,
				textTransform: 'uppercase',
			},
			address: {
				fontWeight: 500,
				fontStyle: 'normal',
				[theme.breakpoints.down(collapsePoint)]: {
					marginBottom: remCalc(60),
				}
			},
			'.footer__main__social': {
				display: 'flex',
				alignItems: 'center',
				marginBottom: remCalc(16),
				[theme.breakpoints.up(collapsePoint)]: {
					marginBottom: remCalc(32),
				},
				justifyContent: 'space-around',
				a: {
					display: 'block',
				},
				'.footer__main__social__facebook': {
					width: remCalc(24),
				},
				'.footer__main__social__instagram': {
					width: remCalc(22),
				},
				'.footer__main__social__twitter': {
					width: remCalc(22),
				},
				'.footer__main__social__youtube': {
					width: remCalc(26),
				},
				'.footer__main__social__pinterest': {
					width: remCalc(24),
				},
			},
			'.footer__main__contact': {
				textAlign: 'center',
				[theme.breakpoints.down(collapsePoint)]: {
					marginBottom: remCalc(60),
				},
			},
			'.footer__main__links': {
				[theme.breakpoints.up(collapsePoint)]: {
					justifySelf: 'right',
				},
				ul: {
					margin: 0,
					padding: 0,
					listStyle: 'none',
					columnCount: '2',
					gap: remCalc(32),
					a: {
						display: 'block',
						transition: 'all var(--transition-duration-fast)',
						marginBottom: remCalc(8),
					},
				}
			},
			'.footer__main__top': {
				marginBottom: remCalc(60),
			},
			'.footer__main__bottom': {
				display: 'flex',
				gap: remCalc(60),
				justifyContent: 'center',
				alignItems: 'center',
				[theme.breakpoints.down(collapsePoint)]: {
					'.footer__main__bottom__wctlogo': {
						width: remCalc(99),
					},
					'.footer__main__bottom__kwcblogo': {
						width: remCalc(75),
					},
					'.footer__main__bottom__awlogo': {
						width: remCalc(99),
					},
				},
			},
			[theme.breakpoints.up(collapsePoint)]: {
				textAlign: 'left',
				padding: `${remCalc(96)} 0`,
			},
			'@media (prefers-contrast: more)': {
				background: getColor('blue', 500),
				color: 'white',
			},
		},
	},
	'.footer__bottom': {
		padding: remCalc('30 0'),
		background: getColor('ivory', 400),
		color: getColor('ivory', 700),
		[theme.breakpoints.down(collapsePoint)]: {
			textAlign: 'center',
		},
		'a:link, a:visited': {
			color: getColor('ivory', 700),
			fontWeight: 400,
			textDecorationColor: getColor('ivory', 400),
		},
		'a:hover, a:active': {
			textDecorationColor: getColor('ivory', 700),
		},
		'.footer__bottom__links': {
			[theme.breakpoints.up(collapsePoint)]: {
				justifySelf: 'right',
			},
			ul: {
				margin: 0,
				padding: 0,
				listStyle: 'none',
				display: 'flex',
				[theme.breakpoints.down(collapsePoint)]: {
					justifyContent: 'center',
				},
				li: {
					display: 'block',
					'&:after': {
						content: "''",
						paddingLeft: '8px',
						marginRight: '8px',
						borderRight: `1px solid ${getColor('ivory', 700)}`,
					},
					'&:last-child:after': {
						borderRight: 'none',
					},
				},
			},
		},
		'@media (prefers-contrast: more)': {
			background: 'white',
			color: getColor('ivory', 800),
			'a:link, a:visited': {
				color: getColor('ivory', 800),
				textDecorationColor: 'white',
			},
			'a:hover, a:active': {
				color: getColor('ivory', 900),
				textDecorationColor: getColor('ivory', 900),
			},
		},
	},
}

const styles = {};

export default styles;